import {Component, OnDestroy, OnInit} from '@angular/core';
import {sortingInfo} from '../../../models/filter.model';
import {Order} from '../../../models/orders.model';
import {Router, ActivatedRoute, RouterEvent, NavigationEnd} from '@angular/router';
import {MyoderService} from '../../../my-orders/shared/myoder.service';
import {FileService} from '../../../services/file.service';
import {ManageService} from '../../../services/manage.service';
import {NgProgress} from 'ngx-progressbar';
import {CommonService} from '../../../services';
// tslint:disable-next-line:import-blacklist
import {Subject, of} from 'rxjs';
import {Sort} from '@angular/material/sort';
import {FormControl} from '@angular/forms';
import {debounceTime, distinctUntilChanged, tap, switchMap, filter, takeUntil} from 'rxjs/operators';
import {Observable} from 'rxjs/Observable';

declare var $: any;

@Component({
  selector: 'app-return-search',
  templateUrl: './return-search.component.html',
  styleUrls: ['./return-search.component.css']
})
export class ReturnSearchComponent implements OnInit, OnDestroy {

  title = 'Returns';
  orders: Order[];
  sortedData: Order[];
  // search
  searchField: string;
  sortingInfoObj: sortingInfo = {
    comparedProperty: '',
    sortingOrder: ''
  };
  filterResultArr: any;
  filterInput: string;
  hasEmptyFilterResult = false;
  loadContent = true;

  ngUnsubscribe: Subject<void> = new Subject<void>();

  searchControl: FormControl;
  narrow: boolean = false;
  selectedOrder: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private orderService: MyoderService,
    private manageService: ManageService,
    private fileService: FileService,
    private ngProgress: NgProgress,
    private commonService: CommonService
  ) {
    this.searchControl = new FormControl();
    commonService.emitUpdateSideBarActiveItem('account');
  }

  ngOnInit() {

    // @ts-ignore
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      if (this.router.url == '/myAccount/returns') {
        $('#levelOne').animate({scrollLeft: -250}, 400);
        this.narrow = false;
      } else {
        this.narrow = true;
      }

    });

    const orders$: Observable<Order[]> = this.searchControl.valueChanges.pipe(
      debounceTime(1000),
      distinctUntilChanged(),
      tap(() => {
        this.loadContent = false;
        this.hasEmptyFilterResult = false;
        this.sortedData = this.orders = [];
      }),
      switchMap((keyword: string) => {
        if (keyword) {
          return this.orderService.getShippedOrders(keyword).pipe(
            switchMap((orders) => {
              if (Array.isArray(orders)) {
                return of(orders);
              } else {
                return of([]);
              }
            })
          );
        } else {
          return of([]);
        }
      })
    );

    orders$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value: Order[]) => {
      this.orders = value.filter(v => v.dateInvoiced !== null && v.dateInvoiced !== '');
      if (this.orders.length === 0) {
        this.hasEmptyFilterResult = true;
      }
      this.sortedData = this.orders.slice();
      this.loadContent = true;
    });


  }

  filterReset() {
    this.searchControl.setValue('');
    this.hasEmptyFilterResult = false;
  }

  goReturnsDetail(order: Order) {
    this.router.navigate([order.orderNo, order.orderSuffix], {relativeTo: this.route});
    this.selectedOrder = `${order.orderNo}-${order.orderSuffix}`;
  }

  ngOnDestroy() {
    this.commonService.emitUpdateSideBarActiveItem('');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  close() {
    this.router.navigateByUrl('/myAccount');
  }

  sortData(sort: Sort) {
    const data = this.orders.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'invoiveNo':
          return compare(a.orderNo, b.orderNo, isAsc);
        case 'invoiceDate':
          return compare(a.dateInvoiced.split('-').reverse().join('-'), b.dateInvoiced.split('-').reverse().join('-'), isAsc);
        case 'resellerPO':
          return compare(a.resellerPO, b.resellerPO, isAsc);
        case 'totalEx':
          return compare(parseFloat(a.totalEx), parseFloat(b.totalEx), isAsc);
        default:
          return 0;
      }
    });
  }

  exportOrderSerials(orderNumber: string, orderSuffix: string) {
    this.orderService.exportExportOrderSerials(orderNumber, orderSuffix)
      .subscribe(data => {
          const fileName = `DD_OrderSerials_${orderNumber}.xlsx`;
          this.fileService.saveAsExcelFile(data, fileName);
        },
        (error: any) => {
          console.error(error);
        });
  }

  convertTotal(total: string) {
    if (total.includes('-')) {
      return `-$${total.replace('-', '')}`;
    } else {
      return '$' + total;
    }
  }

}

function compare(a, b, isAsc) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
